import React from 'react';
import localization from '@progressivebeef/shared/src/localization/i18n';
import { getLocale } from '@progressivebeef/shared/src/services/storageService/GlobalData';
import './style.scss';

const RecordSops = ({ sops }) => {
  if (!sops || sops.length === 0) return null;
  return (
    <div className="detail-section">
      <div className="detail-label">
        {localization[getLocale()].SOPs}:
      </div>
      <div className="sops-tags-box">
        {sops.map((sop, index) => (
          <div key={index} className="sop-tag">
            {sop.sop_number}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecordSops;
